module.exports = __webpack_public_path__ + "c3e4a76ff73f535ab98ae5efa6c312b6.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_4_0.woff2
// module id = 540
// module chunks = 0